export class ImmoTaskAssetType {
  label?: string;
  ordinal?: number;

  constructor(label: string, ordinal: number) {
    this.label = label;
    this.ordinal = ordinal;
  }
}

export const IMMO_TASK_ASSET_TYPE_CHOICES = {
  DESIGN: new ImmoTaskAssetType('Impressie', 0),
  LOCATION: new ImmoTaskAssetType('Locatie', 1),
  EXECUTION: new ImmoTaskAssetType('Uitvoering', 2)
};

export const IMMO_TASK_ASSET_TYPE_CHOICE_ARRAY = Object.values(
  IMMO_TASK_ASSET_TYPE_CHOICES
);
